/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, Dispatch, SetStateAction } from 'react'
import { FormikErrors, FormikTouched } from 'formik'

import { InputLabel, InputError } from '../../../components/Typography'
import { StyledInput } from '../styled'

import { CitiesInput } from './styled'

import { City } from 'src/store/models/user'

type AboutMeProps = {
  setOpenCity: Dispatch<SetStateAction<boolean>>
  onChange: (
    eventOrPath: string | React.ChangeEvent<any>
  ) => void | ((eventOrTextValue: string | React.ChangeEvent<any>) => void)
  values: {
    username: string
    firstName: string
    instagram: string
    twitter: string
  }
  selectedCity: City | undefined
  errors: FormikErrors<{
    username: string
    firstName: string
    instagram: string
    twitter: string
  }>
  touched: FormikTouched<{
    username: string
    firstName: string
    instagram: string
    twitter: string
  }>
  onBlur: (eventOrString: any) => void | ((e: any) => void)
  usernameTaken: boolean | undefined
  usernameCheckError: boolean | undefined
}

const AboutMe: FC<AboutMeProps> = ({
  onChange,
  values,
  setOpenCity,
  selectedCity,
  errors,
  touched,
  onBlur,
  usernameTaken,
  usernameCheckError,
}) => {
  return (
    <>
      <InputLabel htmlFor="username">Username</InputLabel>
      <StyledInput
        id="username"
        name="username"
        type="text"
        placeholder="johndoe"
        onChange={onChange}
        value={values.username}
        onBlur={onBlur}
        isError={
          (errors.username && touched.username) ||
          usernameTaken ||
          usernameCheckError
            ? true
            : false
        }
      />
      {errors.username && touched.username && (
        <InputError>{errors.username}</InputError>
      )}
      {usernameTaken && (
        <InputError>This username is already taken.</InputError>
      )}
      {usernameCheckError && <InputError>Error checking username.</InputError>}
      <InputLabel htmlFor="firstName">First Name</InputLabel>
      <StyledInput
        id="firstName"
        name="firstName"
        type="text"
        placeholder="John"
        onChange={onChange}
        value={values.firstName}
        onBlur={onBlur}
        isError={errors.firstName && touched.firstName ? true : false}
      />
      {errors.firstName && touched.firstName && (
        <InputError>{errors.firstName}</InputError>
      )}
      <InputLabel htmlFor="city">City</InputLabel>
      <CitiesInput
        preview={selectedCity ? false : true}
        onFocus={() => setOpenCity(true)}
        onClick={() => setOpenCity(true)}
        tabIndex={0}
      >
        {selectedCity ? selectedCity.name : 'Los Angeles, CA'}
      </CitiesInput>
      <InputLabel htmlFor="instagram">Instagram</InputLabel>
      <StyledInput
        id="instagram"
        name="instagram"
        type="text"
        placeholder="username"
        onChange={onChange}
        value={values.instagram}
      />
      <InputLabel htmlFor="twitter">Twitter</InputLabel>
      <StyledInput
        id="twitter"
        name="twitter"
        type="text"
        placeholder="username"
        onChange={onChange}
        value={values.twitter}
      />
    </>
  )
}

export default AboutMe
